const getDefaultTween = (startValue, endValue, fact) => (startValue + fact * (endValue - startValue));

export {getDefaultTween};
